import { Grid } from '@material-ui/core';
import { CheckoutSessionCriteria } from '@nemuru-eng/js-api-client';

import { PendingBorrowerNameInformation } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/PendingBorrowerNameInformation';
import { Text } from '@/components/shared/components/Text';
import { getFullNameString } from '@/utils/getFullName';

export const checkoutSessionBorrowerNameFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.38,
    field: 'borrowerName',
    sortable: false,
    align: 'left',
    headerName: <Text tId={'CLIENT'} />,
    renderCell: (rowData: { row: CheckoutSessionCriteria }) => {
      const borrowerName = getFullNameString(rowData.row.customer?.fullName) || <PendingBorrowerNameInformation />;
      return (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'break-spaces',
              lineHeight: '1.43',
              width: '100%',
            }}
          >
            <Grid container alignItems={'center'}>
              <Grid item xs={12}>
                <div className={'line-clamp-3'}>{borrowerName}</div>
              </Grid>
            </Grid>
          </div>
        </>
      );
    },
  };
};
